export default __webpack_public_path__ + "static/media/uploadIcon.278f386c.svg";